import React, { Component, createRef } from 'react';

import ReactToPrint from 'react-to-print';

import withRouter from "../components/withRouter";

import EB04PrintContent from './EB04PrintContent';

class EB04Print extends Component {
  constructor(props) {
    super(props);
    this.componentRef = createRef();
  }

  render = () => {

    const { id } = this.props.params;

    return (
      <>
        <div className="mx-auto print-structure">
            <div className="print-toolbars">
                    <div className="me-4 text-end" style={{paddingTop: '8px'}}>
                        <ReactToPrint
                            trigger={() => (
                                <button className="btn btn-sm btn-primary btn-rounded">
                                  <i className="fa-classic fa-light fa-print fa-fw me-2 print-toolbar"/>
                                  พิมพ์เอกสาร
                                </button>
                            )}
                            content={() => this.componentRef.current}
                            documentTitle={`EB04_${id}`}
                            pageStyle={`
                              @page {
                                size: A4;
                                margin: 10mm 0;
                              }
                              body {
                                margin: 0;
                              }
                            `}
                        />
                  </div>
                  <div><hr className="seperate-full" /></div>
            </div>

            <div id="print-section">
                <EB04PrintContent id={id} ref={this.componentRef} />
            </div>
        </div>
      </>
    );
  }
}

export default withRouter(EB04Print);
